import type { FC } from 'react'

import Checkbox from '@/components/Checkbox'

export interface Filter {
  lomond: boolean
  ers: boolean
  other: boolean
}

export const DEFAULT_FILTER: Filter = {
  lomond: true,
  ers: true,
  other: true,
}

interface Props {
  filter: Filter
  onChangeFilter: (filter: Filter) => void
}

const ReferenceGroupFilter: FC<Props> = ({ filter, onChangeFilter }) => (
  <>
    <Checkbox
      label="Lomond"
      checked={filter.lomond}
      onChange={e =>
        onChangeFilter({
          ...filter,
          lomond: e.target.checked,
        })
      }
    />
    <Checkbox
      label="ERS"
      checked={filter.ers}
      onChange={e =>
        onChangeFilter({
          ...filter,
          ers: e.target.checked,
        })
      }
    />
    <Checkbox
      label="Other"
      checked={filter.other}
      onChange={e =>
        onChangeFilter({
          ...filter,
          other: e.target.checked,
        })
      }
    />
  </>
)

export default ReferenceGroupFilter
